import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { IoPersonSharp } from "react-icons/io5";
import { IconContext } from "react-icons";
// import { ReactComponent as User } from "../assets/svg/user.svg";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import { Modal, TextField, Button, InputAdornment } from "@mui/material";

import InfoGridItem from "../components/controlContainer/InfoGridItem";
import ControlContainer from "../components/controlContainer/ControlContainer";
import ReturnToHomeButton from "../components/ReturnToHomeButton";

import { getUserDetails } from "../utils/variables";
import { setUserDetails } from "../features/auth/authSlice";
import { auth, fb } from "../utils/firebase/firebase";

import Swal from "sweetalert2";

const Account = () => {
  const {
    firstName: authFirstName,
    fullName,
    address,
    dateCreated,
    memberExpiry,
    email,
    contactNumber,
    uid,
    isActive,
  } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [showPassword, setshowPassword] = useState(false);
  const [showPassword1, setshowPassword1] = useState(false);
  const [showPassword2, setshowPassword2] = useState(false);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    // console.log("uid :>> ", uid);
    ///Temporary Query
    const handleUserDetails = async () => {
      const {
        firstName,
        lastName,
        fullName,
        birthday,
        address,
        contactNumber,
        dateCreated,
        memberExpiry,
        isActive,
      } = await getUserDetails(uid);
      dispatch(
        setUserDetails({
          firstName,
          lastName,
          fullName,
          birthday,
          address,
          contactNumber,
          dateCreated,
          memberExpiry,
          isActive,
        })
      );
    };

    // if there is no stored userdetails, fetch.
    if (authFirstName === "") {
      handleUserDetails();
    }
  }, [uid, authFirstName, dispatch]);

  // const handleEditProfile = () => {
  //   console.log("editing profile");
  // };

  const reAuth = (currentPassword) => {
    const user = auth.currentUser;
    const cred = fb.auth.EmailAuthProvider.credential(
      user.email,
      currentPassword
    );
    return user.reauthenticateWithCredential(cred);
  };

  const handleShowPassword = () => {
    setshowPassword(!showPassword);
  };

  const handleShowPassword1 = () => {
    setshowPassword1(!showPassword1);
  };

  const handleShowPassword2 = () => {
    setshowPassword2(!showPassword2);
  };

  const handleChangePassword = async () => {
    const user = auth.currentUser;

    if (confirmNewPassword !== newPassword) {
      setOpen(false);
      Swal.fire({
        icon: "error",
        title: "Passwords do not match",
        text: "Please try again",
      });
    } else {
      try {
        await reAuth(password);
        await user.updatePassword(newPassword);
        setOpen(false);
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Password has been changed",
        });
      } catch (error) {
        console.log(error.code);

        if (error.code === "auth/wrong-password") {
          setOpen(false);
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Wrong current password",
          });
        }
        if (error.code === "auth/too-many-requests") {
          setOpen(false);
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Too many attempts please try again later",
          });
        }
      }
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        minHeight: "100vh",
        margin: "auto",
        maxWidth: "965px",
        padding: "0 15px",
      }}
    >
      <Box>
        <h1>Profile and Security</h1>
      </Box>

      <Box
        sx={{
          padding: "20px 0",
          display: "flex",
          justifyContent: "space-between",
          gap: "20px",
        }}
      >
        <IconContext.Provider
          value={{
            style: {
              color: "var(--primary-color)",
              fontSize: "1.5em",
            },
          }}
        >
          {/* User Details */}
          <ControlContainer
            title={fullName.toUpperCase()}
            icon={<IoPersonSharp />}
          >
            <Grid container>
              <InfoGridItem infoKey={"Email"} value={email} />
              <InfoGridItem infoKey={"Contact No."} value={contactNumber} />
              <InfoGridItem infoKey={"Date Created"} value={dateCreated} />
              {/* <InfoGridItem infoKey={"Date of Birth"} value={birthday} /> */}
              <InfoGridItem infoKey={"Address"} value={address} />
            </Grid>
          </ControlContainer>

          {/* Security */}
          <ControlContainer title={"Security"} icon={<IoPersonSharp />}>
            <Grid container>
              <InfoGridItem infoKey={"Email"} value={email} />
              <Grid item xs={5}>
                <p
                  style={{
                    fontSize: "12px",
                    fontWeight: "700",
                    padding: "2px 0",
                    width: "100px",
                    color: "var(--gray-text)",
                  }}
                >
                  Password
                </p>
              </Grid>
              <Grid item xs={7} sx={{ display: "flex" }}>
                <button
                  style={{
                    backgroundColor: "red",
                    fontSize: "8px",
                    color: "white",
                    width: "70px",
                    padding: "3px 0",
                    textAlign: "center",
                    borderRadius: "5px",
                    border: "none",
                    cursor: "pointer",
                    fontWeight: "400",
                  }}
                  onClick={handleOpen}
                >
                  Change
                </button>
              </Grid>
            </Grid>
          </ControlContainer>

          {/* Membership */}
          <ControlContainer title={"Membership"} icon={<IoPersonSharp />}>
            <Box>
              <p>
                {isActive ? "Active until" : "Expired last"} {memberExpiry}
              </p>
            </Box>
          </ControlContainer>
        </IconContext.Provider>
      </Box>

      <ReturnToHomeButton />
      <Modal open={open} onClose={handleClose} className="password--change">
        <div className="card--modal">
          <div className="card__container">
            <h2 className="password__title">Change Password</h2>
            <TextField
              required
              className="password__textfield"
              label="Current Password"
              type={!showPassword ? "password" : "text"}
              onChange={(e) => setPassword(e.target.value)}
              style={{
                marginBottom: "1rem",
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment
                    position="end"
                    onClick={handleShowPassword}
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    {!showPassword ? (
                      <VisibilityOff className="icon" />
                    ) : (
                      <Visibility className="icon" />
                    )}
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              required
              className="password__textfield"
              label="New Password"
              type={!showPassword1 ? "password" : "text"}
              onChange={(e) => setNewPassword(e.target.value)}
              style={{
                marginBottom: "1rem",
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment
                    position="end"
                    onClick={handleShowPassword1}
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    {!showPassword1 ? (
                      <VisibilityOff className="icon" />
                    ) : (
                      <Visibility className="icon" />
                    )}
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              required
              className="password__textfield"
              label="Confirm New Password"
              type={!showPassword2 ? "password" : "text"}
              onChange={(e) => setConfirmNewPassword(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment
                    position="end"
                    onClick={handleShowPassword2}
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    {!showPassword2 ? (
                      <VisibilityOff className="icon" />
                    ) : (
                      <Visibility className="icon" />
                    )}
                  </InputAdornment>
                ),
              }}
            />
            <Button
              variant="contained"
              className="password__button"
              onClick={handleChangePassword}
            >
              SUBMIT
            </Button>
          </div>
        </div>
      </Modal>
    </Box>
  );
};

export default Account;
